<template>
  <div>
    <button v-if="!onlyModal" class="btn btn-xs btn-default" @click="$emit('abrir')">{{ openLabel }}</button>
    <div v-if="showModal" @close="showModal = false">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container" 
                role="dialog"  
                aria-modal="true"
                :aria-hidden="!showModal"
                :style="{ width: width }">

              <div v-if="!hideHeader" class="modal-header">
                <slot name="header">{{ title }}</slot>
                <div class="pull-right">
                  <button type="button" class="close" aria-label="Fechar" @click="$emit('fechar')">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div id="modal-content" class="modal-body">
                <slot name="body"></slot>
              </div>

              <div v-if="!hideFooter" class="modal-footer">
                <slot name="footer">
                  <div class="sr-only" id="btn-fechar-aria-hint">Para fechar esta janela pressione as teclas F2 + Enter</div>
                  <button id="btn-fechar" class="btn btn-primary pull-right" aria-describedby="btn-fechar-aria-hint" aria-labelledby="modal-content" ref="fechar" @click="$emit('fechar')">{{ closeLabel }}</button>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
.modal-body {
  margin: 20px 0;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>

<script>
export default {
  name: 'meta-modal',
  props: {
    title: {
      type: String,
      default: 'Atenção',
    },
    openLabel: {
      type: String,
      default: '',
    },
    closeLabel: {
      type: String,
      default: 'Fechar',
    },
    onlyModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '400px',
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  mounted() {
    this.$on('abrir', () => {
      this.abrir();
    });
    this.$on('fechar', () => {
      this.fechar();
    });
  },
  methods: {
    abrir() {
      this.showModal = true;
      this.$nextTick(() => {
        if(this.$refs.fechar) {
          this.$refs.fechar.focus();
        }
      });
    },
    fechar() {
      this.showModal = false;
    },
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/meta-modal/src/Modal.vue